// =====================================================
// API Service - Backend Communication
// =====================================================

import axios from 'axios';
import { Message } from '../types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 * Send chat message
 */
export async function sendMessage(params: {
  session_id: string | null;
  user_id?: string;
  message: string;
  language: string;
  current_url: string;
}): Promise<any> {
  const response = await api.post('/api/chat', {
    session_id: params.session_id,
    user_id: params.user_id,
    message: params.message,
    language: params.language,
    current_url: params.current_url,
    timestamp: new Date().toISOString(),
    user_hour: new Date().getHours()  // User's local hour for time-based greeting
  });

  return response.data;
}

/**
 * Submit lead form (generic)
 */
export async function submitLead(leadData: {
  session_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  community_of_interest?: string;
  lead_type: string;
  message?: string;
}): Promise<any> {
  const response = await api.post('/api/leads', leadData);
  return response.data;
}

/**
 * Submit Tour Request form
 * Saves to bh_chatbot_analytics.lead_submissions
 */
export async function submitTourRequest(leadData: {
  session_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  city_of_interest?: string;
  community_of_interest?: string;
  address_or_floor_plan?: string;
  // Separate columns for home address and floor plan name
  home_address?: string;
  floor_plan_name?: string;
  comments?: string;
  lead_type: string;
  source_url?: string;
  // Inquiry source tracking
  inquiry_type?: 'quick_move_in' | 'floor_plan' | 'community' | 'general';
  home_id?: number;
  floor_plan_id?: number;
  community_id?: number;
  region_id?: number;
}): Promise<any> {
  const response = await api.post('/api/leads', leadData);
  return response.data;
}

/**
 * Get session data
 */
export async function getSession(sessionId: string): Promise<any> {
  const response = await api.get(`/api/session/${sessionId}`);
  return response.data;
}

/**
 * Update language
 */
export async function updateLanguage(
  sessionId: string,
  language: string
): Promise<any> {
  const response = await api.post('/api/language', {
    sessionId,
    language
  });
  return response.data;
}

export default api;